import {
  Button, Card, Grid, Typography,
} from '@mui/material';
import React from 'react';
import logo01 from '../../imagens/logo-linkfish.png';
import logo02 from '../../imagens/logistica-linkfish.png';
import DialogContact from 'pages/instructions/dialogContact';
import './styles.css';
import styleGlobal from '../../Global.module.css';

function SellWithUs() {
  return (
    <header className={styleGlobal.headerGlobal}>
      <Card style={{ padding: '3rem', borderRadius: '20px' }}>
        <Typography align="center">
          <img src={logo01} className="logo01" />
        </Typography>
        <h2>
          Uma Plataforma Inteligente de comercialização construída com a união
          entre os especialistas da carcinicultura e piscicultura.
        </h2>
        <i className="subTitle">
          "Realize a sua Compra/Venda de forma mais rápida, fácil e econômica.”
        </i>
        <p>
          A Plataforma tem a capacidade de analisar a faixa de preço, o tamanho
          do animal, o peso, o período da despesca, a espécie do animal, a
          localização dos viveiros, entre outras informações, que são cruciais
          tanto para o produtor quanto para o comprador negociarem a
          compra/venda. Dessa forma, é possível realizar, através da plataforma,
          uma pesquisa avançada e inteligente que ainda não existe atualmente
          neste mercado. Com esse sistema, o cliente (produtor ou comprador)
          terá mais segurança e facilidade para suprir as suas necessidades.
        </p>
        <Typography align="center" style={{ paddingBlock: '2rem' }}>
          <img src={logo02} className="logo02" />
        </Typography>

        <a
          target="_blank"
          href="https://www.app.linkfish.com.br/inicio"
          className="link"
          rel="noreferrer"
        >
          <Button
            style={{
              width: '25.75rem',
              height: '2.9375rem',
              backgroundColor: '#0076C6',
              color: '#fff',
              borderRadius: '15px',
              padding: '15px',
              cursor: 'pointer',
              border: 'none',
              fontSize: '16px',
            }}
          >
            Acessar LinkFish
          </Button>
        </a>
      </Card>
      <Grid container justifyConten="center">
        <DialogContact />
      </Grid>
    </header>
  );
}

export default SellWithUs;
